import React, { useEffect, useState } from 'react';
import CheckBox from '../../../../Shared/CheckBox/Checkbox';
import PopUp from '../../../../Shared/Popup/PopUp';
import noImage from './images/no-image.png';
import Config from '../../../../../Config';
import PremiumPackagePopup from './PremiumPackagePopup'
import Image from 'app/Components/Shared/Image/image';
import loadingIcon from './images/icon-loading.svg';
import checkmateIcon from './images/icon-checkmark.svg';

const PremiumPackages = (props) => {
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [isOpenChangePackagePopup, setIsOpenChangePackagePopup] = useState(false);
  const [currentSelectedVas, setCurrentSelectedVas] = useState([]);
  const [currentUnselectedVas, setCurrentUnselectedVas] = useState([]);

  useEffect(() => {
    if (selectedPackage != null) {
      var selected = props.premiumPackages.find(x => x.name == selectedPackage.name)
      setSelectedPackage(selected);
    };

  }, [props.premiumPackages]);

  const priceItemList = (premiumPackage) => {
    if(premiumPackage.priceItemList?.length > 0){
      return (<div className='price-wrapper'>
        {premiumPackage.priceItemList.map((item, index) => {
          return (
            <div className='price-row' key={index}>
              {index == 0 && <div><span className='text'>₪</span><span className='price'>{item.price}</span></div>}
              <div className='text'>{item.priceTextPremiumPackages} {index != 0 &&  '₪' + item.price }</div>
            </div> )
        })}
      </div>)
    }else if(premiumPackage.price != premiumPackage.originalPrice){
      return (<div className='price-wrapper'>
        <div className='price-row'>₪<span className='price'>{premiumPackage.price}</span> לחודש</div>
        <div className='price-row'><span className='original-price'>₪<sapn className="price">{premiumPackage.originalPrice}</sapn></span> לחודש</div>
      </div>)
    }
  }




  const price = (premiumPackage) => {
    if (premiumPackage.isPremiumPackagesWorld) {
      let price = "";
      let text = "";
      let isShowPrefixText = false;
      let hasSpecialPrice = false;
      const selectedPremiumPackages = premiumPackage.premiumPackages.filter(x => x.action.toUpperCase() == "ADD");
      if (selectedPremiumPackages?.length > 0) {
          price = selectedPremiumPackages.reduce((total, item) => Math.abs(parseFloat(total) + parseFloat(item.price)).toFixed(2), 0);
          text = getDurationText(selectedPremiumPackages[0].duration, 'price');
          if(premiumPackage.priceItemList || premiumPackage.price != premiumPackage.originalPrice){
            hasSpecialPrice = true;
          }
      }
      else {
        isShowPrefixText = true;
        price = Math.min(...premiumPackage.premiumPackages.map(x => x.price));
        text = "החל מ - ";
      }

      if(hasSpecialPrice){
        return priceItemList(premiumPackage);
      }
      else{
        return (<div className='price-wrapper'>{isShowPrefixText && <span className="price-prefix">{text}</span>}₪<span className='price'>{price}</span>{!isShowPrefixText && text}</div>)
      }

    }
    if ((premiumPackage.price == '' || (premiumPackage.price == '0' && premiumPackage.originalPrice == '0')) && premiumPackage.lowerLimit == 0) {
      return (<div className='price-wrapper'>ללא עלות</div>)
    }
    else if (!premiumPackage.vasList || premiumPackage.vasList.length == 0) {
      if(premiumPackage.priceItemList?.length > 0 || premiumPackage.price != premiumPackage.originalPrice){
        return priceItemList(premiumPackage);
      }
      else{
        return (<div className='price-wrapper'>₪<span className='price'>{premiumPackage.price}</span>{getDurationText(premiumPackage.duration, 'price')}</div>)
      }
    }
    else if (premiumPackage.vasList && premiumPackage.vasList.length > 0 && premiumPackage.lowerLimit == 0) {
      let price = "";
      let text = "";
      let isShowPrefixText = false;
      let hasSpecialPrice = false;
      const checkedVas = premiumPackage.vasList.find(x => x.action.toUpperCase() == "ADD");
      if (premiumPackage.action.toUpperCase() == "ADD") {
        price = premiumPackage.price;
        text = getDurationText(premiumPackage.duration, 'price');
        if(premiumPackage.priceItemList?.length > 0 ||  premiumPackage.price != premiumPackage.originalPrice){
          hasSpecialPrice = true;
        }
      }else if (checkedVas) { //Days
        price = checkedVas.price;
        text = getDurationText(checkedVas.duration, 'price');
      }else {
        isShowPrefixText = true;
        price = Math.min(...premiumPackage.vasList.map(vas => vas.price));
        text = "החל מ - "
      }
      if(hasSpecialPrice){
        return priceItemList(premiumPackage);
      }
      else{
        return (<div className='price-wrapper'>{isShowPrefixText && <span className="price-prefix">{text}</span>}₪<span className='price'>{price}</span>{!isShowPrefixText && text}</div>)
      }
    }
  }

  function openChangePackagePopup(premiumPackage) {
    setSelectedPackage(premiumPackage);
    const isMainPackageSelected = premiumPackage.action?.toUpperCase() == "ADD";
    const selectedVas = premiumPackage.vasList?.find(x => x.action.toUpperCase() == "ADD");
    if (isMainPackageSelected) {
      props.onPremiumPackageChange(premiumPackage.name, false, premiumPackage);
    }
    else if (selectedVas) {
      props.onPremiumPackageChange(selectedVas.name, false, premiumPackage);
    }
    else {
      setCurrentSelectedVas([]);
      setCurrentUnselectedVas([]);
      setIsOpenChangePackagePopup(true);
    }
  }

  function openMoreDetailsPopup(premiumPackage) {
    setSelectedPackage(premiumPackage);
    setCurrentSelectedVas([]);
    setCurrentUnselectedVas([]);
    setIsOpenChangePackagePopup(true);
  }

  const moreDetailsBtn = (premiumPackage) => {
    if (!premiumPackage.isPremiumPackagesWorld && (!premiumPackage.vasList || premiumPackage.vasList?.length == 0) || (premiumPackage.vasList?.length > 0 && premiumPackage.lowerLimit == 1)) {
      return (<button className='more-details-btn' onClick={() => { openMoreDetailsPopup(premiumPackage) }}>לפרטים נוספים</button>)
    }
  }

  function onPremiumPackageChange(isSelected, premiumPackage) {
    setSelectedPackage(premiumPackage);
    props.onPremiumPackageChange(premiumPackage.name, isSelected, premiumPackage)
  }

  function handleOnVasSelected(vasName) {
    if (!selectedPackage.isPremiumPackagesWorld) {
      props.handleOnVasSelected(vasName, selectedPackage)
    }
    setIsOpenChangePackagePopup(false)
  }

  function handleOnPremiumPackagesWorldChange(isSelected, premiumPackageName) {
    const result = props.onPremiumPackageChange(premiumPackageName, isSelected, selectedPackage);
    if (isSelected) {
      if (!currentSelectedVas.includes(premiumPackageName)) {
        setCurrentSelectedVas([...currentSelectedVas, premiumPackageName]);
      }
    }
    else {
      setCurrentUnselectedVas([...currentUnselectedVas, premiumPackageName]);
    }
    return result;
  }

  function handleOnSingleChoiceWorldSwitch(itemsToDeselect, itemToSelect) {
    itemsToDeselect.forEach(item => {
      setCurrentUnselectedVas(prev => [...prev, item.name]);
    });
    setCurrentSelectedVas(prev => [...prev.filter(n => !itemsToDeselect.find(x => x.name === n)), itemToSelect]);
    return props.onSingleChoiceWorldSwitch(itemsToDeselect, itemToSelect, selectedPackage);
  }

  function closeVasesPopUp() {
    setIsOpenChangePackagePopup(false);
    currentSelectedVas?.forEach(selectedVas => {
      props.onPremiumPackageChange(selectedVas, false, selectedPackage);
    });
    currentUnselectedVas?.forEach(selectedVas => {
      props.onPremiumPackageChange(selectedVas, true, selectedPackage);
    });
  }

  const packageButton = (premiumPackage) => {
    const isShowLoading = premiumPackage?.name == selectedPackage?.name && props.isLoadingShoppingCart;
    if (premiumPackage.isPremiumPackagesWorld) {
      const selectedPackages = premiumPackage.premiumPackages.filter(x => x.action.toUpperCase() == "ADD");
      const isSelected = selectedPackages?.length == 0 ? false : true;
      const btnText = selectedPackages?.length == 1 ? 'החבילה נבחרה' :
        selectedPackages?.length > 1 ? 'החבילות נבחרו' : 'בחירת  חבילה';
        const iconToShow = isShowLoading ? loadingIcon.bg() : isSelected ? checkmateIcon.bg() : '';

   return (<button className='package-btn' onClick={() => { openChangePackagePopup(premiumPackage) }}>{btnText}{(isShowLoading || isSelected) &&
      <span className='selected'><span
      style={{ backgroundImage: iconToShow }}
      className={` ${isShowLoading ? 'loading' : isSelected ? 'checkmate' : ''}`}></span></span>}</button>) 
      }
    else {
      const packageRemovable = premiumPackage.lowerLimit == 0;
      if (packageRemovable) {
        if (!premiumPackage.vasList) {
          const isAdded = premiumPackage.action.toUpperCase() == "ADD";
          const isSelected = isAdded ? false : true;
          const btnText = isAdded ? 'החבילה נבחרה' : 'בחירת חבילה';
          const iconToShow = isShowLoading ? loadingIcon.bg() : isAdded ? checkmateIcon.bg() : '';
          return (<button className='package-btn' onClick={() => 
            { onPremiumPackageChange(isSelected, premiumPackage) }}>{btnText}{(isShowLoading || isAdded) &&
              <span className='selected'>
              <span style={{ backgroundImage: iconToShow }}
               className={` ${isShowLoading ? 'loading' : isAdded ? 'checkmate' : ''}`}></span></span>}
                </button>)
        }
        else if (premiumPackage.vasList?.length > 0) {
          const isMainPackageSelected = premiumPackage.action.toUpperCase() == "ADD";
          const isVasSelected = premiumPackage.vasList.some(x => x.action.toUpperCase() == "ADD");
          const isSelected = isMainPackageSelected || isVasSelected;
          const btnText = (isSelected) ? 'החבילה נבחרה' : 'בחירת סוג חבילה';
          const iconToShow = isShowLoading ? loadingIcon.bg() : isSelected ? checkmateIcon.bg() : '';
          return (<button className='package-btn' onClick={() => { openChangePackagePopup(premiumPackage) }}>
            {btnText}{(isShowLoading || isSelected) && 
             <span className='selected'>
             <span style={{ backgroundImage: iconToShow }}
             className={` ${isShowLoading ? 'loading' : isSelected ? 'checkmate' : ''}`}></span></span>}</button>)
        }
      }
      else {
        return (<div className='package-include'><span className='checkmate' />כלול בחבילה שלך </div>)
      }
    }
  }

  const clickDiv = (premiumPackage)=> {
    props.gtag4({
      event: `${props.saleType}_Step5_PremiumPackageButton`,
      step: '5',
      button: 'בחירת חבילה',
      package: premiumPackage?.billDescription,
      action:  'PremiumPackageButton',
      funnel_name: `${props.saleType}_Exists${props.flowType == 'existsCustomer' ? '_Exists' : '_New'}_Customer`
    });
  };

  const getDurationText = (duration, type, text) => {
    let checkboxText = "";
    let priceText = "";

    switch (duration.amount) {
      case "0":
        checkboxText = "חבילה חודשית";
        priceText = " לחודש";
        break;
      case "1":
        if (duration.units.toUpperCase() == "DAY") {
          checkboxText = "חבילה יומית";
          priceText = " ליום";
        }
        if (duration.units.toUpperCase() == "MONTH") {
          checkboxText = "חבילה חודשית";
          priceText = " לחודש";
        }
        break;
      case "2":
        if (duration.units.toUpperCase() == "DAY") {
          checkboxText = "חבילה ליומיים";
          priceText = " ליומיים";
        }
        if (duration.units.toUpperCase() == "MONTH") {
          checkboxText = "חבילה לחודשיים";
          priceText = " לחודשיים";
        }
        break;
      default:
        if (duration.units.toUpperCase() == "DAY") {
          checkboxText = text ? text : 'חבילה ל' + duration.amount + ' ימים';
          priceText = " ל-" + duration.amount + ' ימים';
        }
        if (duration.units.toUpperCase() == "MONTH") {
          checkboxText = text ? text : 'חבילה ל' + duration.amount + ' חודשים';
          priceText = " ל-" + duration.amount + ' חודשים';
        }
        break;
    }
    if (type == 'checkbox') return checkboxText;
    if (type == 'price') return priceText;
  }

  return (
    <div className='premium-packages'>
      {props.premiumPackagesByGroups && (Object.keys(props.premiumPackagesByGroups).length > 1) ?
        Object.keys(props.premiumPackagesByGroups).map(function (key) {
          const categoryList = props.premiumPackagesByGroups[key];
          const categoryName = key;
          let categoryIcon = categoryList[0].cmsData?.categories.find(category => category.categoryName == key)?.categoryIcon ?? null;
          return (
            <div key={key} className='category-wrapper'>
              {categoryName && <div className='category-name'>{categoryIcon && <Image className='category-icon' src={Config.epiBaseUrl + categoryIcon} alt='category icon' />} {categoryName}</div>}
              <div className='premium-package-list'>
                {categoryList.map(function (item, i) {
                  const image = item.cmsData?.desktopImage ? Config.epiBaseUrl + item.cmsData?.desktopImage : noImage;
                  const labelIcon = item.cmsData?.labelIcon ?? null;
                  const labelText = item.cmsData?.labelText ?? null;
                  return (
                    !item.cmsData?.isHidden &&
                    <div className='premium-package' key={i} style={{ backgroundImage: 'url(' + image + ')' }} onClick={()=>clickDiv(item)}>
                      {labelText && <div className='tag'>{labelIcon && <Image className='tag-icon' src={Config.epiBaseUrl + labelIcon} alt='tag icon' />} {labelText}</div>}
                      <div className='package-content'>
                        <div className='package-title'>{item.cmsData?.title ? item.cmsData?.title : item.billDescription}</div>
                        {price(item)}
                        {moreDetailsBtn(item)}
                        {packageButton(item)}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )
        }) :
        <div className='premium-package-list'>
          {props.premiumPackages?.map(function (item, i) {
            const image = item.cmsData?.desktopImage ? Config.epiBaseUrl + item.cmsData?.desktopImage : noImage;
            const labelIcon = item.cmsData?.labelIcon ?? null;
            const labelText = item.cmsData?.labelText ?? null;
            return (
              !item.cmsData?.isHidden &&
              <div className='premium-package' key={i} style={{ backgroundImage: 'url(' + image + ')' }}>
                {labelText && <div className='tag'>{labelIcon && <Image className='tag-icon' src={Config.epiBaseUrl + labelIcon} alt='tag icon' />} {labelText}</div>}
                <div className='package-content'>
                  <div className='package-title'>{item.cmsData?.title ? item.cmsData?.title : item.billDescription}</div>
                  {price(item)}
                  {moreDetailsBtn(item)}
                  {packageButton(item)}
                </div>
              </div>
            );
          })}
        </div>
      }
      <PopUp showPopUp={isOpenChangePackagePopup} onClose={() => { closeVasesPopUp() }}>
        <PremiumPackagePopup context={props.context} closePopUp={() => { closeVasesPopUp() }} onPremiumPackagesWorldChange={handleOnPremiumPackagesWorldChange} onSingleChoiceWorldSwitch={handleOnSingleChoiceWorldSwitch} premiumPackage={selectedPackage} onVasSelected={handleOnVasSelected} getDurationText={getDurationText} />
      </PopUp>
    </div>
  );

};

export default PremiumPackages;
